import React, { useState } from 'react';
import { Paragraph, SmallParagraph, Hyperlink } from './Submitted.styles';
import { useHistory } from 'react-router';
import { FormStep, InputType, MultistepForm } from 'view/components/common';
import { IApplication, noop } from 'core/utilities';
import { completeApplication } from 'core/api';

interface Props
{
    onContinue : () => void;
}

const Message : React.FunctionComponent<Props> = () => {
    return (
        <>
            <Paragraph>
                Thank you for your application; you are now on the waitlist.
            </Paragraph>
            <Paragraph>
                Please note that we have a minimum wait period of 24 months, contingent on available funds. Once it is your turn for home financing, we will review your file and be in touch on next steps.
            </Paragraph>
            <Paragraph>
                In the meantime, you can invest the money you are saving for your downpayment with us and earn a Halal return for your RRSP, TFSA, RESP, or any registered and non-registered investment account. Click <Hyperlink href='https://manzil.ca/halal-money' target='blank'>here</Hyperlink> for more information.
            </Paragraph>
            <SmallParagraph>
                If you have any questions or concerns, please feel free to email us at salaam@manzil.ca.
            </SmallParagraph>
            <Paragraph>
                We look forward to serving you!
            </Paragraph>
            <Paragraph>
                Jazāk Allāhu Khayran
            </Paragraph>
        </>
    );
};

const formSteps = [
    [
        {
            type : InputType.info,
            Component : Message
        }
    ],
    []
] as Array<FormStep>;

export const Submitted : React.FunctionComponent<{ application: IApplication }> = ({ application }) => {
    const history = useHistory();
    const [ clicked, setClicked ] = useState(false);

    const onNext = {
        0 : async () => {
            setClicked(true);
            
            await completeApplication(application.id);

            history.push('/dashboard');
        }
    };

    return (
        <MultistepForm
            title='Application Submitted'
            initialValues={{}}
            formSteps={formSteps}
            onNext={onNext}
            onSubmit={noop}
            disabled={clicked}
        />
    );
};
